import { render, staticRenderFns } from "./WatchNowButton.vue?vue&type=template&id=97833fcc"
import script from "./WatchNowButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchNowButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports